import { topicItems } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading text-foreground-900 mb-3">
              热门话题
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              追剧圈最火热的讨论话题，看看大家都在聊什么
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3 md:gap-4">
            {topicItems.map((topic) => (
              <div
                key={topic.name}
                className="group flex items-center gap-2.5 px-4 py-2.5 md:px-5 md:py-3 bg-background-100 border border-background-200/70 rounded-lg hover:border-primary-300 hover:bg-background-50 transition-all duration-200 cursor-pointer"
              >
                <span className="text-sm md:text-base text-foreground-800 whitespace-nowrap">
                  #{topic.name}
                </span>
                <span className="text-xs text-foreground-400 whitespace-nowrap">
                  {topic.heat}
                </span>
                {topic.tag && (
                  <span
                    className={`text-xs px-1.5 py-0.5 rounded font-medium whitespace-nowrap ${
                      topic.tag === '爆'
                        ? 'bg-accent-500 text-background-50'
                        : topic.tag === '热'
                          ? 'bg-primary-100 text-primary-700'
                          : 'bg-secondary-100 text-secondary-700'
                    }`}
                  >
                    {topic.tag}
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}